/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
/**
 * 平面表单控制器前缀
 */
export const POWER_PLANE_CONTROL_NAME_PREFIX = 'powerPlane';


/**
 * 电源模式枚举0：均衡电源 1：主电源 2：备电源
 */
export enum PowerModelTypeE {
    EQUALIZED = '0',
    MAIN = '1',
    STANDBY = '2'
}

/**
 * 框当前实际电源模式枚举 0:负载均衡模式;1:主备供电模式
 */
export enum CurSupplyModeTypeE {
    EQUALIZED = '0',
    MAIN_OR_STANDBY = '1'
}

/**
 * 框当前配置电源模式枚举 0:负载均衡模式;1:主备供电模式
 */
export enum SystemSupplyModeTypeE {
    EQUALIZED = '0',
    MAIN_OR_STANDBY = '1'
}

/**
 * 框是否支持主备供电模式,返回的是string
 */
export enum IsSupportMSPowerModeTypeE {
    NOT_SUPPORT = 'false',
    SUPPORT = 'true'
}
